<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <circle cx="8.8" cy="8.8" r="8.8" stroke="#000" stroke-linecap="square" stroke-width="1.6"/>
        <circle cx="8.8" cy="13.6" r="1" fill="#000" fill-rule="nonzero"/>
        <path stroke="#000" stroke-linecap="square" stroke-width="1.6" d="M7.082 4.448c1.584-.7 3.634-.617 4.334.516.7 1.133.217 2.45-.983 3.467S8.8 10 8.8 10.8"/>
    </g>
</svg>
